import * as e from "react";
var a = /* @__PURE__ */ e.createContext(null);
function f(i) {
  var s = i.children, r = i.onBatchResize, t = e.useRef(0), o = e.useRef([]), n = e.useContext(a), v = e.useCallback(function(c, u, l) {
    t.current += 1;
    var d = t.current;
    o.current.push({
      size: c,
      element: u,
      data: l
    }), Promise.resolve().then(function() {
      d === t.current && (r == null || r(o.current), o.current = []);
    }), n == null || n(c, u, l);
  }, [r, n]);
  return /* @__PURE__ */ e.createElement(a.Provider, {
    value: v
  }, s);
}
export {
  f as Collection,
  a as CollectionContext
};
//# sourceMappingURL=Collection.mjs.map
